export default __webpack_public_path__ + "static/media/black_logo.844f4dff.png";